// extracted by mini-css-extract-plugin
module.exports = {"snowCanvas":"index-snowCanvas-2srRj"};